import { NewsList as News } from './NewsList'
import { OpportunitiesList as Opportunities } from './OpportunitiesList'
import { OpportunitiesListOfCard } from './OpportunitiesListOfCard'
import { OPPORTUNITY_TYPE_ENUM as Summary } from './SummaryList'

export default { News, Opportunities, OpportunitiesListOfCard, Summary }
